import { render, staticRenderFns } from "./ParametersTab.vue?vue&type=template&id=49db1a08&scoped=true&"
import script from "./ParametersTab.vue?vue&type=script&lang=js&"
export * from "./ParametersTab.vue?vue&type=script&lang=js&"
import style0 from "./ParametersTab.vue?vue&type=style&index=0&id=49db1a08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49db1a08",
  null
  
)

export default component.exports